module.exports = __webpack_public_path__ + "media/alpaca.e70eb1ed.mp3";